/*jshint esversion: 6 */
import Vue from 'vue';
export default new Vue();


// WEBPACK FOOTER //
// ./src/services/eventBus.js